<template>
    <div class="index">
        <div class="box">
            <div class="top">
                <div class="item" @click="goTojizhang">
                    <div class="page">
                        <div class="title">快速记账</div>
                        <div class="word">
                            快速记录销售订单
                        </div>
                        <div class="bot">
                            <img src="../../../public/images/index1.png" alt="" />
                            <div class="text">去查看</div>
                        </div>
                    </div>
                </div>
                <div class="item" @click="goToorder">
                    <div class="page">
                        <div class="title">订单管理</div>
                        <div class="word">
                            查看和管理订单
                        </div>
                        <div class="bot">
                            <img src="../../../public/images/index2.png" alt="" />
                            <div class="text">去查看</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="middle">
                <div class="tt" @click="goTocustomer">
                    <div class="lef">
                        <div class="title">客户管理</div>
                        <div class="word">
                            管理客户信息和还款
                        </div>
                        <div class="text">去查看</div>
                    </div>
                    <div class="righ">
                        <img src="../../../public/images/index3.png" alt="" />
                    </div>
                </div>
                <div class="bb">
                    <div class="item" @click="goTowallet">
                        <div class="title">羊场钱包</div>
                        <div class="word">
                            记录每日收支和余额
                        </div>
                        <div class="bot">
                            <img src="../../../public/images/index4.png" alt="" />
                            <div class="text">去查看</div>
                        </div>
                    </div>
                    <div class="item" @click="goTopici">
                        <div class="title">批次管理</div>
                        <div class="word">
                            管理羊只批次
                        </div>
                        <div class="bot">
                            <img src="../../../public/images/index4.png" alt="" />
                            <div class="text">去查看</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'index',
        data() {
            return {

            }
        },

        mounted() {
            this.checkLogin();
        },

        methods: {
            goTojizhang() {
                this.$router.push({
                    path: '/jizhang',
                })
            },
            goToorder() {
                this.$router.push({
                    path: '/order',
                })
            },
            goTocustomer() {
                this.$router.push({
                    path: '/customer',
                })
            },
            goTopici() {
                this.$router.push({
                    path: '/pici',
                })
            },
            goTowallet() {
                this.$router.push({
                    path: '/wallet',
                })
            },
            // 登录验证
            checkLogin(){
                const loading = this.$loading({
                    "lock": true,
                    "text": '',
                    "spinner": 'el-icon-loading',
                    "background": 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/wallet_role/getWalletRoleList').then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                    } else {
                        this.$message({
                            "type": 'error',
                            "message": res.data.msg
                        })
                    }
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .index {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: #E1EAFD;
    }

    .box {
        position: fixed;
        left: 50%;
        top: 50%;
        z-index: 2;
        min-width: 90%;
        transform: translate(-50%, -50%);

        .top {
            display: flex;
            justify-content: space-between;

            .item {
                flex: 0 0 48%;
                background: #C8D4FF;
                border-radius: 12px 12px 12px 12px;
                padding: 12px;
                box-sizing: border-box;
                cursor: pointer;
                .page {
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    padding: 12px;
                    box-sizing: border-box;

                    .title {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 20px;
                        color: #36363A;
                    }

                    .word {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9B9CA1;
                    }

                    .bot {
                        display: flex;
                        align-items: flex-end;
                        justify-content: space-between;

                        img {
                            display: block;
                            width: 70px;
                            height: 70px;
                        }

                        .text {
                            padding: 0 12px;
                            background: #EAEFFF;
                            border-radius: 163px 163px 163px 163px;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #3F72FF;
                            line-height: 30px;
                        }
                    }
                }
            }
        }

        .middle {
            margin-top: 24px;
            background: linear-gradient(180deg, #C8D4FF 0%, #D1D8FF 100%);
            border-radius: 12px 12px 12px 12px;
            padding: 12px;
            box-sizing: border-box;
            cursor: pointer;
            .tt {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                margin-bottom: 24px;
                padding: 12px;
                box-sizing: border-box;

                .lef {
                    .title {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 20px;
                        color: #36363A;
                    }

                    .word {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9B9CA1;
                        line-height: 30px;
                    }

                    .text {
                        margin-top: 42px;
                        display: inline-block;
                        padding: 0 12px;
                        background: #EAEFFF;
                        border-radius: 163px 163px 163px 163px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #3F72FF;
                        line-height: 30px;
                    }
                }

                .righ {
                    img {
                        display: block;
                        width: 120px;
                        height: 120px;
                    }
                }
            }

            .bb {
                display: flex;
                justify-content: space-between;

                .item {
                    flex: 0 0 40%;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    padding: 12px;
                    box-sizing: border-box;
                    cursor: pointer;
                    .title {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 20px;
                        color: #36363A;
                    }

                    .word {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9B9CA1;
                    }

                    .bot {
                        display: flex;
                        align-items: flex-end;
                        justify-content: space-between;

                        img {
                            display: block;
                            width: 70px;
                            height: 70px;
                        }

                        .text {
                            padding: 0 12px;
                            background: #EAEFFF;
                            border-radius: 163px 163px 163px 163px;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #3F72FF;
                            line-height: 30px;
                        }
                    }
                }

                .item:last-child {
                    flex: 0 0 56%;
                }
            }

        }
    }
</style>
